const _ModuleRegistry = Ice._ModuleRegistry;
const Slice = Ice.Slice;

const cwms = _ModuleRegistry.module("cwms");

const iceC_cwms_Plugin_ids = [
  "::Ice::Object",
  "::cwms::Plugin"
];

cwms.Plugin = class extends Ice.Object {};

cwms.PluginPrx = class extends Ice.ObjectPrx {};

Slice.defineOperations(cwms.Plugin, cwms.PluginPrx, iceC_cwms_Plugin_ids, 1, {
  "business": [, , , , [7],
    [
      [7],
      [7]
    ], , , ,
  ]
});

const communicator = Ice.initialize();
const proxy = communicator.stringToProxy("SimplePlugin:ws -h 127.0.0.1 -p 10001");
cwms.doPrint = async (request, callback) => {
  const printer = await cwms.PluginPrx.checkedCast(proxy);
  if (printer)
  {
    // console.log('===doPrint======' + request.requestData.PrintDatas[0].FIELD4 + request.requestData.PrintDatas[0].TEMPLETETYPE)
    return await printer.business("DoPrint", JSON.stringify(request));
  }
  // return cwms.PluginPrx.checkedCast(proxy).then((printer) => {
  //   return printer.business("DoPrint", JSON.stringify(request));
  // });
}


cwms.doPrintComm = async (request, callback) => {
  const communicator = Ice.initialize();
  const proxy = communicator.stringToProxy("SimplePlugin:ws -h 127.0.0.1 -p 10001");
  const printer = await cwms.PluginPrx.checkedCast(proxy);
  if (printer)
  {
    // console.log('===doPrint======' + request.requestData.PrintDatas[0].FIELD4 + request.requestData.PrintDatas[0].TEMPLETETYPE)
    return await printer.business("DoPrint", JSON.stringify(request));
  }
  // return cwms.PluginPrx.checkedCast(proxy).then((printer) => {
  //   return printer.business("DoPrint", JSON.stringify(request));
  // });
}

cwms.getWeight = () => {
  return cwms.PluginPrx.checkedCast(proxy).then((printer) => {
    return printer.business("GetWeight", '');
  });
}

export default cwms


// WEBPACK FOOTER //
// ./src/utils/Printer.js